import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Truck, ChefHat, LogOut, Sandwich } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { Button } from "@/components/ui/button";

export default function StaffLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isRepartidor = user?.role === "repartidor";
  const isElaborador = user?.role === "elaborador";

  const role = user?.role || "staff";
  const roleLabel = isRepartidor ? "Reparto" : isElaborador ? "Cocina" : "Staff";

  // For repartidor/elaborador we expose only their relevant tab.
  // Admins/encargados can switch (used in /admin too via direct routes).
  const tabs = [];
  if (isElaborador || user?.role === "admin" || user?.role === "encargado") {
    tabs.push({ to: "/staff/cocina", label: "Cocina", icon: ChefHat });
  }
  if (isRepartidor || user?.role === "admin" || user?.role === "encargado") {
    tabs.push({ to: "/staff/despacho", label: "Despacho", icon: Truck });
  }

  return (
    <div className="min-h-screen bg-[#F9F6F0] text-[#1A1A1A]">
      <header className="sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-[#E5E0D8]">
        <div className="max-w-[1400px] mx-auto px-3 sm:px-5 h-16 flex items-center justify-between gap-2">
          <div className="flex items-center gap-3 min-w-0">
            <div className="h-11 w-11 rounded-lg bg-white p-1 ring-1 ring-[#E5E0D8] shadow-sm shrink-0">
              <img src="/logo.png" alt="" className="h-full w-full object-contain" />
            </div>
            <div className="leading-tight min-w-0">
              <div className="font-display font-bold text-[14px] sm:text-[15px] truncate">Sandwichs Lo De Dani</div>
              <div className="text-[9px] sm:text-[10px] uppercase tracking-[0.18em] text-[#C85A32] font-semibold">{roleLabel}</div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div className="hidden sm:flex items-center gap-2 text-[#595959] text-sm">
              <Sandwich className="h-4 w-4 text-[#C85A32]" />
              <span className="truncate max-w-[140px]">{user?.nombre || user?.email}</span>
            </div>
            <Button variant="outline" size="sm" onClick={logout} className="border-[#E5E0D8] gap-1.5" data-testid="staff-logout">
              <LogOut className="h-4 w-4" />
              <span className="hidden sm:inline">Salir</span>
            </Button>
          </div>
        </div>
        {tabs.length > 1 && (
          <nav className="max-w-[1400px] mx-auto px-3 sm:px-5 pb-1.5 flex gap-2">
            {tabs.map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to} to={to}
                className={({ isActive }) =>
                  `inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-semibold transition-colors ${isActive
                    ? "bg-[#C85A32] text-white"
                    : "text-[#595959] hover:bg-[#F4EAE6]"
                  }`
                }
                data-testid={`staff-tab-${to.split("/").pop()}`}
              >
                <Icon className="h-4 w-4" />
                {label}
              </NavLink>
            ))}
          </nav>
        )}
      </header>

      <main className="max-w-[1400px] mx-auto px-3 sm:px-5 py-4 sm:py-6">
        <Outlet />
      </main>

      <Toaster position="top-center" richColors />
    </div>
  );
}
